var map = {
	"./advanced.svg": "0af4",
	"./apps.svg": "d2e5",
	"./basic.svg": "c1ad",
	"./chart.svg": "c22b",
	"./close.svg": "029d",
	"./collapse.svg": "4f43",
	"./components.svg": "72fb",
	"./dashboard.svg": "28be",
	"./ecommerce.svg": "841f",
	"./email.svg": "8a1c",
	"./error.svg": "7a91",
	"./form_elements.svg": "90cf",
	"./horizontal.svg": "0f27",
	"./icons.svg": "5b5e",
	"./layouts.svg": "e43d",
	"./logout.svg": "5d39",
	"./maps.svg": "f3bc",
	"./notifications.svg": "0146",
	"./pages.svg": "9e11",
	"./search.svg": "113d",
	"./settings.svg": "fc12",
	"./tables.svg": "7b90",
	"./user.svg": "636e",
	"./verticle.svg": "63d3",
	"./widgets.svg": "f0c2",
	"./widgets_old.svg": "6e3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "978d";